import { render, staticRenderFns } from "./FormSendTripToSupplier.vue?vue&type=template&id=149066c6"
import script from "./FormSendTripToSupplier.vue?vue&type=script&lang=js"
export * from "./FormSendTripToSupplier.vue?vue&type=script&lang=js"
import style0 from "./FormSendTripToSupplier.vue?vue&type=style&index=0&id=149066c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports